import { loadStripe } from "@stripe/stripe-js";
import AccountApi from "../api/AccountApi";

/** Begin initializing Stripe */
export async function initializeStripe() {
    const response = await AccountApi.GetRegistrationTokens();
    const stripeKey = response?.stripeKey;

    if (stripeKey) {
        console.log("Initializing Stripe client with public key: ", stripeKey);
        return loadStripe(stripeKey);
    } else {
        throw new Error(
            "Unable to retrieve Stripe key with AccountApi.GetRegistrationTokens()"
        );
    }
}
